/**
 * BestMvFooterLink — the homepage footer's link to the ranked list of the
 * best AI music video generators, under the list's own name in the page's
 * language (shared/bestMvInboundLinks.ts). Rendered in LandingV2's footer.
 * The homepage crawler HTML already links the list (renderInternalLinks in
 * server/_core/seo.ts); the hydrated homepage had no link to it. A real
 * <a href> that navigates client-side on a plain click.
 */
import type { MouseEvent } from "react";
import { useLanguageRouter } from "@/hooks/useLanguageRouter";
import { bestMvListName } from "@shared/bestMvInboundLinks";

const BEST_MV_PATH = "/best-ai-music-video-generator";

export default function BestMvFooterLink() {
  const { currentLang, withLanguagePath, navigate } = useLanguageRouter();

  const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
      return;
    }
    e.preventDefault();
    navigate(BEST_MV_PATH);
  };

  return (
    <a href={withLanguagePath(BEST_MV_PATH)} onClick={onClick}>
      {bestMvListName(currentLang)}
    </a>
  );
}
